<template>
  <div>
    <div class="user-list">
      <h1 class="title is-4">All Companies</h1>
      <div class="loading-components" v-if="companies < 1"><span class="loader"></span></div>
      <table class="table is-bordered is-striped is-fullwidth">
        <thead>
          <tr>
            <th>Company Name</th>
            <th>Company Number</th>
            <th>Discount List ID</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr :key="index" v-for="(company, index) in companies">
            <td>{{company.name}}</td>
            <td>{{company.number}}</td>
            <td>{{company.discountListID}}</td>
            <td>
              <div class="buttons is-right">
                <a class="button is-danger is-small is-outlined" @click="deleteCompany(company.number, index)">
                  <span>Delete</span>
                  <span class="icon is-small">
                    <i class="icon ion-md-close"></i>
                  </span>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import errorHandler from '@/errorHandler';

export default {
  data() {
    return {
      companies: [],
    };
  },

  created() {
    this.fetchUsers();
  },

  methods: {
    fetchUsers() {
      fetch('/api/company/list', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(res => res.json())
        .catch(error => errorHandler(error))
        .then((response) => {
          this.companies = response.companies;
        });
    },

    deleteCompany(number, index) {
      fetch(`/api/company/${number}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(res => res.json())
        .catch(error => errorHandler(error))
        .then((response) => {
          this.companies.splice(index, 1);
          this.$awn.success(`${response.message}`);
        });
    },
  },
};
</script>

<style lang="scss">
.user-list {
  margin-top: 20px;
}

.loading-components {
  margin-bottom: 10px;
}
</style>
